import { render, staticRenderFns } from "./finished-dialog.vue?vue&type=template&id=ef5165e6"
import script from "./finished-dialog.vue?vue&type=script&lang=ts"
export * from "./finished-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports